declare namespace $ {

	export class $shm_hitalama_version_label extends $mol_view {
		title( ): string
		version( ): string
		date( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=label.view.tree.d.ts.map